module.exports = __webpack_public_path__ + "img/INOBAL.4a880272.jpg";